import { ContentFieldType } from "../../../types/cms/contentField.type";
import { GalleryImageConfig } from "../../image/types";
import { SINGLE_TOKEN_REGEX } from "../internal/constants";
import { resolvePath } from "../internal/resolvePath";
import { resolveConditionals } from "../internal/resolveConditionals";
import type { InterpolateParams } from "../types";

/**
 * Extrai `GalleryImageConfig[]` de um template single-token
 * `{{path|gallery}}`. Retorna `undefined` se o template não for
 */
export function extractGallery({
  structure,
  template,
}: InterpolateParams): GalleryImageConfig[] | undefined {
  const match = resolveConditionals({ template, structure }).match(SINGLE_TOKEN_REGEX);
  if (!match) return undefined;

  const [, path, type] = match;
  if (type !== ContentFieldType.GALLERY && type !== ContentFieldType.IMAGE)
    return undefined;

  const value = resolvePath(structure, path);
  if (Array.isArray(value)) return value as GalleryImageConfig[];

  if (type !== ContentFieldType.IMAGE || value == null) return undefined;

  if (typeof value === "string") {
    return value.trim() === ""
      ? undefined
      : ([value] as unknown as GalleryImageConfig[]);
  }

  if (typeof value === "object") {
    return [value] as unknown as GalleryImageConfig[];
  }

  return undefined;
}
